import React, { Component } from 'react';
import collapseIcon from '../../../../assets/icons/collapse.svg';
import expandIcon from '../../../../assets/icons/expand.svg';
import { footerLinks, appLinks, copy, logos, copyright, banner } from './footerLinks';

export class DefaultFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      footerExpanded: false
    };
  }

  toggleFooter() {
    this.setState(prevState => ({ footerExpanded: !prevState.footerExpanded }));
  }

  render() {
    return (
      <div className="default-footer" data-test-id="default-footer">
        <div className="footer-toggle" onClick={this.toggleFooter.bind(this)} data-test-id="footer-toggle">
          {this.state.footerExpanded ? 'Collapse' : 'Expand'} Footer
          <img src={this.state.footerExpanded ? collapseIcon : expandIcon} className="footer-toggle-icon" data-test-id="footer-toggle-icon" />
        </div>
        {this.state.footerExpanded && (
          <div className="footer-expanded" data-test-id="footer-expanded">
            <div className="footer-divider" />
            <div className="footer-main">
              <div className="footer-links">
                {footerLinks.map((category, index) => {
                  const { title, links } = category;
                  return (
                    <div key={index} className="footer-link">
                      <div className="footer-link-title">{title}</div>
                      <div className="footer-divider footer-divider-gap" />
                      {links.map((link, i) => {
                        const { url, text } = link;
                        return (
                          <a key={i} href={url} target="_blank" rel="noopener noreferrer" className="footer-link-text">{text}</a>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
              <div className="footer-divider" />
              {appLinks(false)}
              <div className="footer-divider" />
              {copy}
              <div className="footer-divider" />
              {logos(false)}
              <div className="footer-divider" />
              {copyright}
            </div>
            {banner}
          </div>
        )}
      </div>
    );
  }
}

export default DefaultFooter;
